import { database } from "firebase/app";

import { IBookInfo } from "../store/modules/library/IBookInfo";

export const updateRecord = (path: string[], patch: Partial<IBookInfo>) => {
  const recordId = path[path.length - 1];
  const folderId = path[path.length - 2];
  const bookPath = `/books/${recordId}`;
  const folderPath = `/folders/${folderId}${bookPath}`;

  const updates = Object.entries(patch).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [`${bookPath}/${key}`]: value,
      ...(
        key.toLowerCase() !== "text"
          ? { [`${folderPath}/${key}`]: value, }
          : {}
      ),
    }),
    {}
  );

  return database().ref().update(updates);
};
